



if (!customElements.get('product-selector')) {
    class ProductSelector extends HTMLElement {
      constructor() {
        super();
        this.selectedOptions = {};
        this.isQuickviewSelector = !!this.closest('product-quickview');
        this.productBar = document.querySelector('product-bar');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.mainProduct = this.closest('main-product');
        this.variants = JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        );

        
        this.addEventListener('change', this.onVariantChange);
  
        this.updateOptions();
      }
  
      connectedCallback() {
        this.form = document.querySelector(this.dataset.formId);
        this.recipientForm =
          this.mainProduct?.querySelector('form-recipient');
        this.quantity = this.form.elements.quantity;
        this.installmentsForm = document.querySelector(
          this.dataset.installmentsFormId
        );
        this.submitButton = this.form.elements.add;
  
        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );
        if (this.quantity) {
          this.quantity.addEventListener(
            'change',
            this.onQuantityChange.bind(this)
          );
        }
        if (this.isQuickviewSelector) return;
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('variant')) return;
        this.updateOptions();
        this.updateVariant();
        this.updateMedia({});
      }
  
      onQuantityChange(event) {
        const productBarQuantity = this.productBar?.querySelector(
          '[name="quantity"]'
        );
        if (productBarQuantity) {
          productBarQuantity.value = event.target.value;
        }
      }
  
      cartSubmitHandler() {
        this.submitButton.classList.add('disabled');
        const sectionsToRender = [
          {
            id: '#cart-counter',
            section: 'cart-counter',
            selector: '#shopify-section-cart-counter'
          },
          {
            id: '#main-cart',
            section: 'main-cart',
            selector: '#main-cart'
          }
        ];
  
        addToCart(
          this.form,
          sectionsToRender.map(section => section.section)
        )
          .then(response => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
  
            this.handleErrorMessage();
  
            if (this.isQuickviewSelector) {
              const quickviewModal = this.closest('modal-dialog');
              quickviewModal.hide();
            }
  
            if (window.location.pathname !== routes.cart_url) {
              window.location.href = routes.cart_url;
              return;
            }
  
            if (!response?.sections['main-cart']) {
              location.reload();
            }
            sectionsToRender.map(section => {
              const sectionToGet = section.section;
              if (!response?.sections[sectionToGet]) return;
  
              const source = new DOMParser().parseFromString(
                response.sections[sectionToGet],
                'text/html'
              );
  
              if (!source) return;
  
              const target = source.querySelector(section.selector);
              const destination = document.querySelector(section.id);
  
              if (!target || !destination) return;
  
              destination.innerHTML = target.innerHTML;
            });
  
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('disabled');
          });
      }
  
      defaultSubmitHandler() {
        this.submitButton.classList.add('disabled');
  
        addToCart(
          this.form,
          this.cartDrawer
            .getSectionsToRender()
            .map(section => section.section)
        )
          .then(response => {
            if (response.status) {
              this.recipientForm?.displayErrorMessage(response.errors);
              this.handleErrorMessage(response.description);
              return;
            }
  
            this.handleErrorMessage();
  
            if (this.isQuickviewSelector) {
              const quickviewModal = this.closest('modal-dialog');
              quickviewModal.hide();
            }
            this.cartDrawer.renderContents(response);
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('disabled');
          });
      }
  
      onSubmitHandler(event) {
        event.preventDefault();
  
        if (
          window.location.pathname == routes.cart_url ||
          !this.cartDrawer
        )
          return this.cartSubmitHandler();
        if (this.cartDrawer) return this.defaultSubmitHandler();
      }
  
      handleErrorMessage(errorMessage = false) {
        const errorWrapper = this.querySelector('[data-error-wrapper]');
        if (!errorWrapper) return;
        errorWrapper.classList.toggle('hidden', !errorMessage);
  
        if (typeof errorMessage === 'object') return;
  
        errorWrapper.textContent = errorMessage || '';
      }
  
      onVariantChange(event) {
        if (
          event.target.type === 'number' ||
          event.target.name === 'id'
        )
          return;
  
        this.updateLabel(event);
        this.updateOptions();
        const changedOptionName = event.target.dataset.name;
        const changedOptionValue = event.target.value;
        if (this.selectedOptions[changedOptionName] !== changedOptionValue) {
          this.selectedOptions[changedOptionName] = changedOptionValue;
          this.updateOptions();
          this.autoSelectVariant(changedOptionName);
        }
  
        this.productBarUpdateOptions();
        this.updateVariant();
        this.toggleAddButton(false, '');
        this.handleErrorMessage();
        if (!this.currentVariant) {
          this.toggleAddButton(true, '');
          this.setUnavailable();
  
          return;
        }
        if (!this.currentVariant.available)
          this.toggleAddButton(true, window.variantStrings.soldOut);
        this.updateMedia({
          name: event.target.dataset.name,
          value: event.target.value
        });
        this.updateURL();
        this.updateVariantInput();
        this.fetchProductInfo();
       
        if (this.currentVariant && this.currentVariant.price) {
          const price = this.currentVariant.price;
  
          const priceAfterTax = price/100 * 1.1;
  
          const formattedPriceAfterTax = new Intl.NumberFormat('ja-JP', {
            style: 'currency',
            currency: 'JPY',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(priceAfterTax);
  
          const finalPriceString = formattedPriceAfterTax + '（tax.in）';
  
          const priceElement = document.querySelector(".price__regular");
          const sku_code = document.querySelector(".variant-sku");
          if (priceElement) {
            priceElement.textContent = finalPriceString;
          }
          sku_code.textContent = this.currentVariant.sku;
        }
        if (this.updatingVariant) return;
      }
  
        findMatchingVariant() {
        const option1Value = this.options.find(option => option.name === 'シーズン')?.value;
        const option2Value = this.options.find(option => option.name === 'サイズ')?.value;
    
        return this.variants.find(variant =>
          variant.option1 === option1Value && variant.option2 === option2Value
        );
      }
  
          autoSelectVariant(changedOptionName) {
            const option1Value = this.options.find(option => option.name === 'シーズン')?.value;
            const option2Value = this.options.find(option => option.name === 'サイズ')?.value;
            console.log('this.variants', this.variants);
            let availableVariant = this.variants.find(variant =>
              variant.option1 === option1Value && variant.option2 === option2Value
            );
            console.log('availableVariant', availableVariant);
            if (!availableVariant) {
              availableVariant = this.variants.find(variant =>
                variant.available === true && (changedOptionName === 'シーズン' ? variant.option1 === option1Value : variant.option2 === option2Value)
              );
              console.log('availableVariant2', availableVariant);
              if (availableVariant) {
                this.updateVariantSelection(availableVariant);
              }
              console.log("availableVariant2", availableVariant);
            }
            if (!availableVariant) {
              availableVariant = this.variants.find(variant =>
                variant.available === false && (changedOptionName === 'シーズン' ? variant.option1 === option1Value : variant.option2 === option2Value)
              );
              console.log('availableVariant2', availableVariant);
              if (availableVariant) {
                this.updateVariantSelection(availableVariant);
              }
              console.log("availableVariant2", availableVariant);
            }
  
              
          }
        
          updateVariantSelection(variant) {
            this.updatingVariant = true;
            const optionInputs = Array.from(this.querySelectorAll('input[type="radio"], select'));
        
            optionInputs.forEach(input => {
              if (input.dataset.name === 'シーズン' && variant.option1) {
                input.value = variant.option1;
                input.dispatchEvent(new Event('change', { 'bubbles': true }));
              }
              if (input.dataset.name === 'サイズ' && variant.option2) {
                input.value = variant.option2;
                input.dispatchEvent(new Event('change', { 'bubbles': true }));
              }
            });
            
            this.currentVariant = variant;
            this.updatingVariant = false;
          }
  
      updateLabel(event) {
        const valueHolder = event.target
          .closest('fieldset')
          ?.querySelector('[data-option-selected-value]');
        if (!valueHolder) return;
        valueHolder.textContent = event.target.value;
      }
  
      updateOptions() {
        this.options = Array.from(
          this.querySelectorAll('input[type="radio"]:checked, select'),
          el => ({ name: el.dataset.name, value: el.value })
        );
      }
  
      productBarUpdateOptions() {
        if (!this.productBar || this.isQuickviewSelector) return;
  
        Array.from(this.productBar.querySelectorAll('[data-name]')).map(
          selector => {
            selector.value = this.options.find(
              option => option.name === selector.dataset.name
            ).value;
          }
        );
      }
  
      updateVariant() {
        this.currentVariant = this.options.length
          ? this.variants.find(variant =>
              variant.options.every((option, index) => 
                this.options[index] && this.options[index].value === option)
            )
          : this.variants[0];
      }
  
      updateMedia(data) {
        if (!this.currentVariant) return;
  
        if (this.isQuickviewSelector) {
          const quickview = this.closest('product-quickview');
          const images = quickview.querySelectorAll('[data-image]');
          const targetImage = Array.from(images).find(image => {
            return (
              image.dataset.variantIds?.includes(
                String(this.currentVariant.id)
              ) || image.dataset[`image${data.name}`] === data.value
            );
          });
  
          if (!targetImage) return;
  
          images.forEach(image =>
            image.classList.toggle('hidden', targetImage !== image)
          );
  
          return;
        }
  
        const productMedia =
          this.closest('main-product')?.querySelector('product-media');
        if (!productMedia) return;
        if (productMedia.hasAttribute('data-gallery-filter')) {
          productMedia.filterMedia(data);
          return;
        }
        productMedia.setActiveMedia(
          this.currentVariant.featured_media?.id || ''
        );
      }
  
      updateURL(sellingPlanId) {
        if (!this.currentVariant) return;
        const parent =
          this.closest('product-quickview') ||
          this.closest('main-product');
        parent
          .querySelector('[data-go-to-product]')
          ?.setAttribute(
            'href',
            `${
              this.isQuickviewSelector
                ? parent.dataset.url
                : this.dataset.url
            }/?variant=${this.currentVariant.id}`
          );
        if (this.isQuickviewSelector) return;
        if (!window.location.pathname.includes('/products')) return;
        const params = new URLSearchParams(window.location.search);
        params[params.has('variant') ? 'set' : 'append'](
          'variant',
          this.currentVariant.id
        );
        if (sellingPlanId) {
          params[params.has('selling_plan') ? 'set' : 'append'](
            'selling_plan',
            sellingPlanId
          );
        } else {
          params.delete('selling_plan');
        }
        window.history.replaceState(
          {},
          '',
          `${this.dataset.url}?${params.toString()}`
        );
      }
  
      updateVariantInput() {
        const inputs = [
          this.form.querySelector('[name="id"]'),
          this.installmentsForm?.querySelector('[name="id"]')
        ];
        inputs.forEach(input => {
          if (!input) return;
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
  
      setUnavailable() {
        const mainPrice = document.querySelector(
          `#Product-Price-${this.dataset.sectionId}`
        );
        const barPrice = this.productBar?.querySelector('[data-price]');
  
        if (!this.submitButton) return;
  
        [
          this.submitButton,
          this.productBar?.querySelector('[type="submit"]')
        ].forEach(submitButton => {
          if (!submitButton) return;
  
          submitButton.querySelector('span').textContent =
            window.variantStrings.unavailable;
        });
        // [mainPrice, barPrice].forEach(priceElement => {
        //   if (priceElement)
        //     priceElement.classList.add('visibility-hidden');
        // });
      }
  
      toggleAddButton(disable, text) {
        const productBarSubmit =
          this.productBar?.querySelector('[type="submit"]');
  
        if (disable) {
          this.submitButton &&
            this.submitButton.setAttribute('disabled', 'disabled');
          !this.isQuickviewSelector &&
            productBarSubmit &&
            productBarSubmit.setAttribute('disabled', 'disabled');
          if (text)
            this.submitButton &&
              (this.submitButton.querySelector('span').textContent =
                text);
          !this.isQuickviewSelector &&
            productBarSubmit &&
            (productBarSubmit.querySelector('span').textContent = text);
        } else {
          this.submitButton &&
            this.submitButton.removeAttribute('disabled');
          !this.isQuickviewSelector &&
            productBarSubmit &&
            productBarSubmit.removeAttribute('disabled');
          this.submitButton &&
            (this.submitButton.querySelector('span').textContent =
              window.variantStrings.addToCart);
          !this.isQuickviewSelector &&
            productBarSubmit &&
            (productBarSubmit.querySelector('span').textContent =
              window.variantStrings.addToCart);
        }
      }
  
      fetchProductInfo(ignoreSellingPlan = false) {
        const params = new URLSearchParams(window.location.search);
        params[params.has('variant') ? 'set' : 'append'](
          'variant',
          this.currentVariant.id
        );
        params.append('section_id', this.dataset.sectionId);
        if (ignoreSellingPlan) params.delete('selling_plan');
        this.setLoading(true);
  
        fetch(`${this.dataset.url}?${params.toString()}`)
          .then(response => response.text())
          .then(responseText => {
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
  
            this.updateLiveRegions(html);
          });
      }
  
      updateLiveRegions(html) {
        const regions = [
          // `#Product-Price-${this.dataset.sectionId}`,
          `#Product-Stock-Notification-${this.dataset.sectionId}`,
          `#Product-Pickup-availability-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`
        ];
        if (!this.isQuickviewSelector) {
          // regions.push('product-bar [data-price]');
        }
        const sourceHTML =
          html
            .querySelector('template#quickview')
            ?.content.firstElementChild.cloneNode(true) || html;
  
        regions.forEach(region => {
          const destination = document.querySelector(region);
          const source = sourceHTML.querySelector(region);
  
          if (!destination && !source) return;
          destination.classList.remove('visibility-hidden');
          destination.innerHTML = source.innerHTML;
        });
        this.setLoading();
      }
  
      setLoading(loading = false) {
        const parent = this.closest('main-product');
        if (!parent) return;
  
        parent.classList.toggle('is-loading', loading);
      }
    }
    customElements.define('product-selector', ProductSelector);
  }




document.addEventListener("DOMContentLoaded", function () {
    var inventoryData = document.getElementById("inventory-data");
    var variantIdElement = document.querySelector('[name="id"]'); // ページのバリアントIDを取得

    if (inventoryData && variantIdElement) {
        try {
            var variants = JSON.parse(inventoryData.innerHTML);
            var selectedVariantId = variantIdElement.value; // 現在の選択バリアントIDを取得
            var selectedVariant = variants.find(v => v.id == selectedVariantId);

            if (selectedVariant) {
                console.log("🔍 バリアントID:", selectedVariantId);
                console.log("📦 在庫状況:", selectedVariant.available ? "在庫あり" : "在庫なし");

                if (selectedVariant.available) {
                    document.querySelectorAll(".line-m").forEach(el => el.style.display = "none");
                    document.querySelectorAll(".socialplus-association-wrapper").forEach(el => el.style.display = "none");
                }
            } else {
                console.warn("❌ バリアントIDが在庫データ内に見つかりません:", selectedVariantId);
            }
        } catch (e) {
            console.error("❌ JSONデータの解析に失敗:", e);
        }
    } else {
        console.warn("⚠️ Liquidからの在庫データまたはバリアントIDが見つかりません。");
    }
});



  